'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SymmetricKey = exports.TAG_LENGTH = exports.SALT_LENGTH = undefined;

var _nodeForge = require('node-forge');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// length of the salt in bytes.
var SALT_LENGTH = exports.SALT_LENGTH = 12;
// length of the tag in bytes.
var TAG_LENGTH = exports.TAG_LENGTH = 16;

var SymmetricKey = exports.SymmetricKey = function SymmetricKey() {
  var _this = this;

  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  _classCallCheck(this, SymmetricKey);

  this.encrypt = function (message) {
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf8';

    var iv = _nodeForge.random.getBytesSync(SALT_LENGTH);
    var ci = _nodeForge.cipher.createCipher('AES-GCM', _this._key);

    // 128 bits is the default MAC tag length that forge uses
    // but we set it explicitly for clarity purposes.
    ci.start({ iv: iv, tagLength: TAG_LENGTH * 8 });
    ci.update(_nodeForge.util.createBuffer(message, encoding));
    ci.finish();

    var ciphertext = '' + iv + ci.output.bytes() + ci.mode.tag.bytes();
    return _nodeForge.util.encode64(ciphertext);
  };

  this.decrypt = function (ciphertext) {
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf8';

    if (ciphertext.length <= SALT_LENGTH + TAG_LENGTH) {
      throw new Error('wrong ciphertext format');
    }
    var encryptedBytes = _nodeForge.util.decode64(ciphertext);
    var iv = encryptedBytes.slice(0, SALT_LENGTH);
    var tag = encryptedBytes.slice(-TAG_LENGTH);
    var ct = encryptedBytes.slice(SALT_LENGTH, -TAG_LENGTH);

    var de = _nodeForge.cipher.createDecipher('AES-GCM', _this._key);
    de.start({ iv: iv, tag: tag });
    de.update(_nodeForge.util.createBuffer(ct));
    if (!de.finish()) {
      throw new Error('error while decrypting');
    }
    return encoding === 'binary' ? Buffer.from(de.output.data, 'binary') : de.output.toString(encoding);
  };

  this.export = function () {
    return {
      key: _nodeForge.util.encode64(_this._key)
    };
  };

  if (!key) this._key = _nodeForge.random.getBytesSync(32);else this._key = _nodeForge.util.decode64(key);
}

/*
  Encrypts a message with the symmetric key.
  The encoding may be specified with the following values: 'utf8' (default), 'ascii', 'binary'
  It formats the encrypted message as follows:
    - base64(<iv><ciphertext><tag>)
*/


/*
  Decrypts a message with the symmetric key.
  The encoding may be specified with the following values: 'utf8' (default), 'ascii', 'binary'.
  Returns the decoded message as a string except if the encoding is set to
  'binary' (in which case the result will be a Buffer or an Uint8Array).
  It accepts a message formatted as follows:
    - base64(<iv><ciphertext><tag>)
*/
;